/**
 * Datos de una orden tal como se muestran en la pantalla de Órdenes
 */

import type { DeskOrder } from '@/services/deskService';
import { formatTime } from '@/lib/orderDays';
import { MAX_COPIES } from './QuantityStepper';

export function tableName(order: DeskOrder): string {
  return order.identification.ticket_name || `Mesa ${order.provider_order_id.slice(-4)}`;
}

export function orderTime(order: DeskOrder): string {
  return order.created_at ? formatTime(new Date(order.created_at)) : '';
}

export function isPrinted(order: DeskOrder): boolean {
  return (order.memory?.print_count ?? 0) > 0;
}

export function hasPhotos(order: DeskOrder): boolean {
  return (order.line_items ?? []).some((item) => item.onboarded);
}

/** Copias iniciales: los comensales si el TPV los conoce, si no 1 */
export function defaultCopies(order: DeskOrder): number {
  const guests = order.identification.guests_count ?? 0;
  return guests > 0 ? Math.min(guests, MAX_COPIES) : 1;
}
